<ng-template [ngxPermissionsOnly]="['campaigns:can_get_campaigns_reports_sales_per_campaign']">
  <div class="box-row panel panel-default">
    <div class="panel-heading">
      <div class="d-flex align-items-center justify-content-space-between">
        <h4>{{widgetTitle}}</h4>
        <div *ngIf="salesByCampaignLoaded" class="refresh-listing-icon" title="Export" (click)="exportChartData()">
          <i class="fa fa-cloud-download fa-lg" aria-hidden="true"></i>
        </div>
      </div>
    </div>
    <div class="panel-body text-center">
      <ng-template [ngIf]="!salesByCampaignLoaded">
        <div class="whirl standard spinnermargin"></div>
      </ng-template>
      <ng-template [ngIf]="salesByCampaignLoaded">
        <ng-container *ngIf="salesByCampaignData.datasets[0].data.length == 0; else displayChart">
          <p>None in the last {{relativeDate}}</p>
        </ng-container>
        <ng-template #displayChart>
          <pie-chart *ngIf="chartType=='pieChart'" [pieData]=salesByCampaignData [showLegends]=true></pie-chart>
          <bar-chart *ngIf="chartType=='barChart'" [chartFor]="'largeSize'" [chartType]="'horizontalBar'" [barData]="salesByCampaignData" [totalCount]="'7'"></bar-chart>
        </ng-template>
      </ng-template>
    </div>
  </div>
</ng-template>